export class PublicPreviewTokensDto {
  public clientIdToken: number;
  public messageIdToken: string;

  constructor(init: any) {
    this.clientIdToken = init.ClientIdToken;
    this.messageIdToken = init.MessageIdToken;
  }
}
